/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

export function updateDeviceInfo(payload: Object) {
  return {
    type: ActionTypes.UPDATE_DEVICE_INFO,
    payload: {
      ...payload,
    },
  };
}

export function getStoreInfo(deviceId: string) {
  return {
    type: ActionTypes.STORE_INFO_REQUEST,
    payload: { deviceId },
  };
}

export function activateDevice(payload: any) {
  return {
    type: ActionTypes.DEVICE_ACTIVATION_REQUEST,
    payload: { ...payload },
  };
}

export function activeDeviceInfo(deviceInfo): any {
  return {
    type: ActionTypes.ACTIVE_DEVICE_INFO,
    payload: deviceInfo,
  };
}

export function reactivateDeviceAction(payload: any) {
  return {
    type: ActionTypes.REACTIVATE_DEVICE_REQUEST,
    payload,
  };
}

export function updateDeviceApiData(payload: Object) {
  return {
    type: ActionTypes.UPDATE_DEVICE_API_DATA,
    payload: {
      ...payload,
    },
  };
}

export function updateDeviceApi(payload: Object) {
  return {
    type: ActionTypes.DEVICE_ACTIVATION_SUCCESS,
    payload: { ...payload },
  };
}
